import { FeatureFlagUser } from '@/types';
import { generateFeatureFlagUser } from '@/utils/generateFeatureFlagUser';
import { PersistentStorageService } from '@/utils/services';

import { InitialBridgeContext, IInteropBridge, ClientType } from './types';

const DEFAULT_SEAWORLD_EMPLOYEE_FEATURE_FLAG_USER: FeatureFlagUser = {
  userId: window.crypto.randomUUID(),
  attributes: { userEmail: 'foo@seaworld.com' },
};

/**
 * Generic fallback for testing outside of a
 * native webview.
 *
 * @class BridgeWeb
 * @implements {IInteropBridge}
 */
export class WebBridgeImpl implements IInteropBridge {
  public clientType: ClientType = ClientType.Web;

  public getInitialBridgeContext(): Promise<InitialBridgeContext> {
    const token = PersistentStorageService.getToken();
    const clientPrivateKeyPem = PersistentStorageService.getClientPrivateKeyPem();
    const driftInSeconds = PersistentStorageService.getDriftInSeconds();
    const brand = PersistentStorageService.getBrand();
    const parkId = PersistentStorageService.getParkId();
    const isInPark: boolean = PersistentStorageService.getIsInPark() ?? false;
    const lat: number = PersistentStorageService.getLat() ?? 0.0;
    const lng: number = PersistentStorageService.getLng() ?? 0.0;
    const featureFlagUser = generateFeatureFlagUser(DEFAULT_SEAWORLD_EMPLOYEE_FEATURE_FLAG_USER);

    return Promise.resolve({
      token,
      brand,
      parkId,
      isInPark,
      lat,
      lng,
      featureFlagUser,
      clientPrivateKeyPem,
      driftInSeconds,
    });
  }

  public launchAccountPage(): void {
    console.log('Launching native account screen.');
  }

  public launchEComm(path: string): void {
    console.log(`Launching native EComm URL path: ${path}`);
  }

  public launchExternalWeb(url: string): void {
    console.log(`Launching native web page: ${url}`);
  }

  public launchNativeSignIn(): void {
    console.log('Launching native sign-in screen.');
  }

  public launchNativeSignUp(): void {
    console.log('Launching native sign-up screen.');
  }

  public launchPhoneCall(tel: string): void {
    console.log(`Launching native phone call: ${tel}`);
  }

  public launchLeaveFeedback(): void {
    console.log('Launching Qualtrics');
  }

  public launchNativeMyPurchasesModal(): void {
    console.log('Launching native my purchases modal.');
  }

  public launchNativeMyPassAndBenefitsModal(): void {
    console.log('Launching native my pass and benefits modal.');
  }

  public launchBilling(): void {
    console.log('Launching native billing.');
  }
}
